<template>
  <div class="space-y-24">
    <RevSkeleton
      class="max-w-full"
      height="32px"
      shape="rectangle"
      width="300px"
    />
    <RevSkeleton height="280px" shape="rectangle" width="100%" />
  </div>
</template>

<script lang="ts" setup>
import { RevSkeleton } from '@ds/components/Skeleton'
</script>
